module.exports = __webpack_public_path__ + "img/industry_solution8.5b8287cc.png";